export default {
  data: () => ({}),
  props: [
    "isOpen",
    "exportSortOptions",
    "buttonText",
    "features",
    "featureGroups",
    "SELECTABLE_EXPORT_SORT_OPTIONS"
  ],
  model: {
    prop: "isOpen",
    event: "close"
  },
  async mounted() {
    if (!this.exportSortOptions) {
      return;
    }
    this.cPrimarySortOption = this.SELECTABLE_EXPORT_SORT_OPTIONS.find(
      sortOption => sortOption.default
    ).id;
  },
  methods: {
    getSortOptionById(id) {
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.find(
        sortOption => id === sortOption.id
      );
    }
  },
  computed: {
    cIsOpen: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit("close", value);
      }
    },
    cPrimarySortOption: {
      get() {
        return this.exportSortOptions.primary;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.primary = sortOption;
      }
    },
    cSecondarySortOption: {
      get() {
        return this.exportSortOptions.secondary;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.secondary = sortOption;
      }
    },
    cThirdSortOption: {
      get() {
        return this.exportSortOptions.third;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.third = sortOption;
      }
    },
    cFourthSortOption: {
      get() {
        return this.exportSortOptions.fourth;
      },
      set(value) {
        const sortOption = this.getSortOptionById(value);
        this.exportSortOptions.fourth = sortOption;
      }
    },
    selectablePrimarySortOptions() {
      if (!this.cSecondarySortOption) {
        return this.SELECTABLE_EXPORT_SORT_OPTIONS;
      }
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
        sortOption =>
          sortOption.id !== this.cSecondarySortOption?.id &&
          sortOption.id !== this.cThirdSortOption?.id
      );
    },
    selectableSecondarySortOptions() {
      if (!this.cThirdSortOption?.id)
        return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
          sortOption => sortOption.id !== this.cPrimarySortOption?.id
        );
      else
        return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
          sortOption =>
            sortOption.id !== this.cPrimarySortOption?.id &&
            sortOption.id !== this.cThirdSortOption?.id &&
            sortOption.id !== this.cFourthSortOption?.id
        );
    },
    selectableThirdSortOptions() {
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
        sortOption =>
          sortOption.id !== this.cPrimarySortOption?.id &&
          sortOption.id !== this.cSecondarySortOption?.id &&
          sortOption.id !== this.cFourthSortOption?.id
      );
    },
    selectableFourthSortOptions() {
      return this.SELECTABLE_EXPORT_SORT_OPTIONS.filter(
        sortOption =>
          sortOption.id !== this.cPrimarySortOption?.id &&
          sortOption.id !== this.cSecondarySortOption?.id &&
          sortOption.id !== this.cThirdSortOption?.id
      );
    }
  }
};
